<section class="playground">
  <h2 class="playground__heading">Select field</h2>

  <p class="playground__hint playground__doc-ref">
    Documentación canónica: <code>docs/CATALOGO-UI.md</code> — sección <strong>Text field</strong> (mismos tokens visuales);
    control nativo: <a href="https://material.angular.dev/components/select/overview" rel="noopener noreferrer" target="_blank">Angular Material — Select</a>.
  </p>

  <div class="playground__section playground__section--modal">
    <h3 class="playground__section-title">Patrón formulario (requerido)</h3>
    <p class="playground__section-hint">
      El <code>FormControl</code> se pasa como <code>[control]</code>. Opciones con <code>label</code> o
      <code>labelKey</code> + translate.
    </p>
    <div class="playground__preview-box playground__preview-box--modal">
      <app-select-field
        [control]="countryControl"
        [options]="countryOptions"
        appearance="outlined"
        widthLayout="fill"
        label="País"
        hint="Selección obligatoria"
        [errorMessages]="countryErrorMessages"
      ></app-select-field>
      <button type="button" class="playground__btn" (click)="markCountryTouched()">Marcar touched (error)</button>
    </div>
  </div>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>appearance</span>
        <select [(ngModel)]="appearance">
          <option *ngFor="let a of appearances" [ngValue]="a">{{ a }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let s of sizes" [ngValue]="s">{{ s }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>widthLayout</span>
        <select [(ngModel)]="widthLayout">
          <option *ngFor="let w of widthLayouts" [ngValue]="w">{{ w }}</option>
        </select>
      </label>
      <label class="playground__field" *ngIf="widthLayout === 'ds'">
        <span>maxWidth (opcional)</span>
        <input type="text" [(ngModel)]="maxWidthCustom" placeholder="Ej. 400px o vacío = 292px" />
      </label>
      <label class="playground__field">
        <span>label</span>
        <input type="text" [(ngModel)]="label" />
      </label>
      <label class="playground__field">
        <span>hint</span>
        <input type="text" [(ngModel)]="hint" />
      </label>
      <label class="playground__field">
        <span>iconLeading</span>
        <input type="text" [(ngModel)]="iconLeading" placeholder="Ej. filter_list" />
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="successful" />
        <span>successful</span>
      </label>
    </div>

    <div class="playground__preview-box">
      <app-select-field
        [control]="demoControl"
        [options]="demoOptions"
        [appearance]="appearance"
        [size]="size"
        [widthLayout]="widthLayout"
        [maxWidth]="widthLayout === 'ds' && maxWidthCustom.trim() ? maxWidthCustom.trim() : undefined"
        [label]="label"
        [hint]="hint || undefined"
        [iconLeading]="iconLeading || undefined"
        [disabled]="disabled"
        [successful]="successful"
      ></app-select-field>
    </div>
  </div>
</section>
